// @flow
import { SET_USER } from "../actions/auth"

let dataState = {
    user: null,
};

const AuthReducer = (state = dataState, action) => {

    var newdata;

    switch (action.type) {

        case SET_USER:
            newdata = Object.assign({}, state);
            newdata.user = action.payload;
            state = Object.assign({}, state, newdata);
            return state;

        default:
            return state;
    }
};

export default AuthReducer;
